import { render, staticRenderFns } from "./SalaryEmployee.vue?vue&type=template&id=0a074b34&scoped=true"
import script from "./SalaryEmployee.vue?vue&type=script&lang=js"
export * from "./SalaryEmployee.vue?vue&type=script&lang=js"
import style0 from "./SalaryEmployee.vue?vue&type=style&index=0&id=0a074b34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a074b34",
  null
  
)

export default component.exports